import Account from "components/Objects/Account";
import AccountSign from "components/Objects/AccountSign";
import AccountBilling from "components/Objects/AccountBilling";
import AccountCloud from "components/Objects/AccountCloud";
import AccountCustomizations from "components/Objects/AccountCustomizations";
import Acquisition from "components/Objects/Acquisition";
import AcquisitionProductUpdate from "components/Objects/AcquisitionProductUpdate";
import AcquisitionPending from "components/Objects/AcquisitionPending";
import AllLocationsArchived from "./AllLocationsArchived"
import AmmoReadyConfig from "./AmmoReadyConfig";
import BoundBookAdd from "components/Objects/BoundBookAdd";
import BoundBookEdit from "components/Objects/BoundBookEdit";
import CaliberAddModal from "./CaliberAddModal";
import Custom880Buyer from "components/Objects/Custom880Buyer";
import CustomerAdd from "components/Objects/CustomerAdd";
import CustomerAddress from "components/Objects/CustomerAddress";
import CustomerBlacklist from "components/Objects/CustomerBlacklist";
import CustomerEdit from "components/Objects/CustomerEdit";
import CustomerEmail from "components/Objects/CustomerEmail";
import CustomerPhone from "components/Objects/CustomerPhone";
import CustomerIdentification from "components/Objects/CustomerIdentification";
import CustomerMilitary from "components/Objects/CustomerMilitary";
import CustomerNicsPermit from "components/Objects/CustomerNicsPermit";
import Dashboard from "components/Objects/Dashboard";
import DavidsonsTransfer from "components/Objects/DavidsonsTransfer";
import Dealer from "components/Objects/Dealer";
import DealerCompare from "components/Objects/DealerCompare";
import Destroy from "components/Objects/Destroy";
import DispositionAdd from "components/Objects/DispositionAdd";
import DispositionEdit from "components/Objects/DispositionEdit";
import DispositionEnicsStatuses from "components/Objects/DispositionEnicsStatuses";
import DispositionNics from "components/Objects/DispositionNics";
import DispositionPending from "components/Objects/DispositionPending";
import DispositionLeep from "components/Objects/DispositionLeep";
import DispositionQuestions from "components/Objects/DispositionQuestions";
import DispositionSignatures from "components/Objects/DispositionSignatures";
import DriversLicenseScan from "components/Objects/DriversLicenseScan";
import DropBoxConnect from "components/Objects/DropBoxConnect";
import EmployeeSign from "components/Objects/EmployeeSign";
import Event from "components/Objects/Event";
import FederalExciseTaxForm from "components/Objects/FederalExciseTaxForm";
import FormSix3A from "components/Objects/FormSix3A";
import FormSix3C from "components/Objects/FormSix3C";
import FormP12 from "./FormP12";
import GunbrokerConfig from "./GunbrokerConfig";
import Export from "components/Objects/Export";
import Inventory from "components/Objects/Inventory";
import Importer from "components/Objects/Importer";
import IoiInspection from "components/Objects/IoiInspection";
import IpBans from "components/Objects/IpBans";
import IpWhitelists from "components/Objects/IpWhitelists";
import Kiosk from "components/Objects/Kiosk"
import LegalEntity from "components/Objects/LegalEntity";
import LegalEntityTrustee from "components/Objects/LegalEntityTrustee";
import LocationAddOns from "components/Objects/LocationAddOns";
import LocationDetail from "components/Objects/LocationDetail";
import Loss from "components/Objects/Loss";
import Manufactured from "components/Objects/Manufactured";
import MarketingBanner from "components/Objects/MarketingBanner";
import ManufacturerAddModal from "./ManufacturerAddModal";
import MarketPlace from "components/Objects/MarketPlace";
import ModuleLearnMore from "components/Objects/ModuleLearnMore";
import NFA from "components/Objects/NFA";
import OnePage from "components/Objects/OnePage";
import AccountCustomizationsPassword from "components/Objects/AccountCustomizationsPassword";
import PointOfSale from "components/Objects/PointOfSale";
import PointOfSaleContact from "components/Objects/PointOfSaleContact";
import ProductAdd from "components/Objects/ProductAdd";
import ProductAddCsv from "components/Objects/ProductAddCsv";
import ProductUpdate from "components/Objects/ProductUpdate";
import Rental from "components/Objects/Rental";
import Reservation from "components/Objects/Reservation";
import ReservationEligibility from "components/Objects/ReservationEligibility";
import SendMyFFL from "components/Objects/SendMyFFL";
import SendToKiosk from "components/Objects/SendToKiosk";
import Signature30Form from "components/Objects/Signature30Form"
import Transfer from "components/Objects/Transfer";
import User from "components/Objects/User";
import UPC from "components/Objects/UPC";
import UPCAdd from "components/Objects/UPCAdd";
import CustomerCompare from "components/Objects/CustomerCompare";
import TransactionUpload from "./TransactionUpload";
import LocationArchive from "./LocationArchive";
import Custom_Export_2669 from "./Custom_Export_2669";


const Objects = {
	Account: Account,
	AccountSign: AccountSign,
	AccountBilling: AccountBilling,
	AccountCloud: AccountCloud,
	AccountCustomizations: AccountCustomizations,
	AccountCustomizationsPassword: AccountCustomizationsPassword,
	Acquisition: Acquisition,
	AcquisitionPending: AcquisitionPending,
	AcquisitionProductUpdate: AcquisitionProductUpdate,
	CaliberAddModal: CaliberAddModal,
	AllLocationsArchived: AllLocationsArchived,
	AmmoReadyConfig: AmmoReadyConfig,
	BoundBookAdd: BoundBookAdd,
	BoundBookEdit: BoundBookEdit,
	Custom880Buyer: Custom880Buyer,
	Custom_Export_2669: Custom_Export_2669,
	CustomerAdd: CustomerAdd,
	CustomerAddress: CustomerAddress,
	CustomerBlacklist: CustomerBlacklist,
	CustomerCompare: CustomerCompare,
	CustomerEdit: CustomerEdit,
	CustomerEmail: CustomerEmail,
	CustomerPhone: CustomerPhone,
	CustomerIdentification: CustomerIdentification,
	CustomerMilitary: CustomerMilitary,
	CustomerNicsPermit: CustomerNicsPermit,
	Dashboard: Dashboard,
	DavidsonsTransfer: DavidsonsTransfer,
	Dealer: Dealer,
	DealerCompare:DealerCompare,
	Destroy: Destroy,
	DispositionAdd: DispositionAdd,
	DispositionEdit: DispositionEdit,
	DispositionEnicsStatuses: DispositionEnicsStatuses,
	DispositionNics: DispositionNics,
	DispositionPending: DispositionPending,
	DispositionLeep: DispositionLeep,
	DispositionQuestions: DispositionQuestions,
	DispositionSignatures: DispositionSignatures,
	DriversLicenseScan: DriversLicenseScan,
	DropBoxConnect: DropBoxConnect,
	EmployeeSign: EmployeeSign,
	Event: Event,
	FederalExciseTaxForm: FederalExciseTaxForm,
	FormSix3A: FormSix3A,
	FormSix3C: FormSix3C,
	FormP12: FormP12,
	GunbrokerConfig: GunbrokerConfig,
	Export: Export,
	Inventory: Inventory,
	Importer: Importer,
	IoiInspection: IoiInspection,
	IpBans: IpBans,
	IpWhitelists: IpWhitelists,
	Kiosk: Kiosk,
	LegalEntity: LegalEntity,
	LegalEntityTrustee: LegalEntityTrustee,
	LocationAddOns: LocationAddOns,
	LocationArchive: LocationArchive,
	LocationDetail: LocationDetail,
	Loss: Loss,
	Manufactured: Manufactured,
	MarketingBanner: MarketingBanner,
	MarketPlace: MarketPlace,
	ModuleLearnMore: ModuleLearnMore,
	NFA: NFA,
	OnePage: OnePage,
	PointOfSale: PointOfSale,
	PointOfSaleContact: PointOfSaleContact,
	ProductAdd: ProductAdd,
	ProductAddCsv: ProductAddCsv,
	ProductUpdate: ProductUpdate,
	Rental: Rental,
	Reservation: Reservation,
	ReservationEligibility: ReservationEligibility,
	SendMyFFL: SendMyFFL,
	SendToKiosk: SendToKiosk,
	Signature30Form: Signature30Form,
	TransactionUpload: TransactionUpload,
	Transfer: Transfer,
	UPC : UPC,
	UPCAdd : UPCAdd,
	User: User,
};

export default Objects;
